(function () {
  var STORAGE_KEY = 'luther_gate_passed';

  var gate = document.getElementById('luther-gate');
  if (!gate) return;

  // Mémorisation le temps de la session de navigation UNIQUEMENT :
  // le CAPTCHA n'apparaît qu'une fois à l'arrivée sur le site.
  // En navigation interne (produit, panier...), il ne redemande pas.
  // Mais si l'onglet/navigateur est fermé puis rouvert, il redemande —
  // pas de mémorisation longue durée (pas de cookie persistant).
  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    gate.setAttribute('data-state', 'hidden');
    document.body.classList.remove('luther-gate-active');
    window.__lutherGatePassed = true;
    document.dispatchEvent(new CustomEvent('luthergatepassed'));
    return;
  }

  document.body.classList.add('luther-gate-active');
  document.body.style.overflow = 'hidden';

  var input = document.getElementById('luther-gate-input');
  var submitBtn = document.getElementById('luther-gate-submit');
  var errorMsg = document.getElementById('luther-gate-error');
  var refreshBtn = document.getElementById('luther-gate-refresh');
  var audioBtn = document.getElementById('luther-gate-audio');

  function normalize(str) {
    return str
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function tryValidate() {
    var value = normalize(input.value || '');

    // Volontairement permissif : n'importe quel mot non vide fonctionne,
    // même avec une faute de frappe. Le CAPTCHA est purement décoratif.
    if (value.length > 0) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      gate.setAttribute('data-state', 'hidden');
      document.body.classList.remove('luther-gate-active');
      document.body.style.overflow = '';
      // Sur mobile, le clavier virtuel peut avoir légèrement décalé le
      // scroll de la page en arrière-plan pendant la saisie — on force
      // le retour en haut de page à la validation.
      window.scrollTo(0, 0);
      // Signal pour les autres scripts (ex: newsletter) : le minuteur
      // de leurs propres délais ne doit démarrer qu'à partir d'ici,
      // pas depuis le chargement initial de la page (sinon le temps
      // passé à taper le CAPTCHA sur mobile est compté à tort).
      window.__lutherGatePassed = true;
      document.dispatchEvent(new CustomEvent('luthergatepassed'));
    } else {
      errorMsg.hidden = false;
      input.focus();
    }
  }

  submitBtn.addEventListener('click', tryValidate);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      tryValidate();
    }
  });

  input.addEventListener('input', function () {
    if (!errorMsg.hidden) {
      errorMsg.hidden = true;
    }
  });

  // Cosmétique uniquement — une seule image fixe, pas de variantes à faire tourner
  if (refreshBtn) {
    refreshBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
    });
  }

  if (audioBtn) {
    audioBtn.addEventListener('click', function () {
      // Pas de vraie piste audio pour le moment — no-op volontaire
    });
  }

  // Focus auto sur le champ à l'ouverture
  window.requestAnimationFrame(function () {
    input.focus();
  });
})();
